import React from 'react'
import { Plane, Vector3 } from 'three'

const xPlane = new Plane(new Vector3(1, 0, 0), 0)
const yPlane = new Plane(new Vector3(0, 1, 0), 0)
const zPlane = new Plane(new Vector3(0, 0, 1), 0)

const Helpers = ({ base, axis = true, x, y, z }) => {
  return (
    <React.Fragment>
      {base && (
        <polarGridHelper
          position={[0, -100, 0]}
          args={[200, 16, 8, 64, 0x333333, 0x666666]}
        />
      )}
      {axis && <axesHelper args={[10]} />}
      {x && <planeHelper args={[xPlane, 20, 0xff6600]} />}
      {y && <planeHelper args={[yPlane, 20, 0x00ff00]} />}
      {z && <planeHelper args={[zPlane, 20, 0x0000ff]} />}
    </React.Fragment>
  )
}

export default Helpers
